<script setup lang="ts">
import type { ConversationalFlowUI } from 'shared/src'
const { t } = useI18n()

const modelValue = defineModel<ConversationalFlowUI>({
  required: true,
})
</script>

<template>
  <div class="flex flex-col space-y-6">
    <OCardAdvanced
      elevation="S"
      border-radius="XL"
      content-class="border border-neutral-5"
      inline
      :title="t('structure_the_conversation')"
      :subtitle="t('configure_the_key_parts_of_the_agents')"
    >
      <div class="col-span-2 flex flex-col space-y-6">
        <OSwitch
          v-model="modelValue.has_welcome_message"
          :label="t('add_welcome_message')"
          :tooltip-content="t('welcome.description')"
          dataTestid="transcription-customer-switch"
        >
          <template #toggleContent>
            <VariableMentionMultiTextArea
              v-if="modelValue.has_welcome_message"
              v-model="modelValue.opening_phrases"
              :fields="['opening_phrase']"
              :placeholders="[t('welcome.placeholder')]"
              :label="t('welcome_phrases')"
              :tooltip-content="t('welcome.subtitle')"
              dataTestid="training_phrase"
            />
          </template>
        </OSwitch>

        <OSwitch
          v-model="modelValue.has_wrap_up_message"
          data-cy="transcription-customer-switch"
          :label="t('add_wrap_up_message')"
          :tooltip-content="t('wrap_up.description')"
          dataTestid="wrap-up-message-switch"
        >
          <template #toggleContent>
            <VariableMentionMultiTextArea
              v-if="modelValue.has_wrap_up_message"
              v-model="modelValue.closing_phrases"
              :fields="['closing_phrase']"
              :placeholders="[t('wrap_up.placeholder')]"
              :label="t('wrap_up_phrases')"
              :tooltip-content="t('wrap_up.subtitle')"
              dataTestid="wrap-up-phrases"
            />
          </template>
        </OSwitch>
      </div>
    </OCardAdvanced>

    <OCardAdvanced
      elevation="S"
      border-radius="XL"
      content-class="border border-neutral-5"
      inline
      :title="t('pronunciation.section_title')"
      :subtitle="t('pronunciation.section_subtitle')"
    >
      <div class="col-span-2 flex flex-col space-y-6">
        <OMultiInput
          v-model="modelValue.replacements"
          :add-label="t('pronunciation.add_replacement')"
          add-mode="progressive"
          :fields="['key', 'value']"
          :placeholders="[t('pronunciation.key_placeholder'), t('pronunciation.value_placeholder')]"
          :label="t('pronunciation.replacements_label')"
          :tooltip-content="t('pronunciation.replacements_description')"
          dataTestid="pronunciation-replacements"
        />
      </div>
    </OCardAdvanced>
  </div>
</template>
